import { render, staticRenderFns } from "./PoolPreviewNet.vue?vue&type=template&id=462cbc66"
import script from "./PoolPreviewNet.vue?vue&type=script&lang=ts"
export * from "./PoolPreviewNet.vue?vue&type=script&lang=ts"
import style0 from "./PoolPreviewNet.vue?vue&type=style&index=0&id=462cbc66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports